const personalOrdersLangCN = {
    myOrder:"我的订单",
    all:"全部",
    obligation:"待付款",
    sendGoods:"待发货",
    shipped:"已发货",
    completed:"已完成",
    canceled:"已取消",
    closed:"交易关闭",
    InvalidOrders:"退款中",
    noMore:"没有更多了",
    orderNumber:"订单编号",
    amountPayable:"立即付款",
    immediatePayment:"应付金额",
    cancellationOrder:"取消订单",
    amountPaid:"已付金额",
    confirmReceipt:"确认收货",
    logistics:"查看物流",
    deleteOrder:"删除订单",
    refund:"查看退款进度",
    cancelHint:"取消订单后，本单享有的优惠可能会一并取消，是否继续？",
    canceltitle:"请选择取消订单的原因（必选）：",
    option1:"配送信息有误",
    option2:"发票信息有误",
    option3:"忘记使用优惠券、积分等",
    option4:"商品买错了",
    option5:"重复下单/误下单",
    bool:"确定"
}

const personalOrdersLangEN = {
    myOrder:"My orders",
    all:"All",
    obligation:"Waiting for payment",
    sendGoods:"Waiting for delivery",
    shipped:"Delivering",
    completed:"Delivered ",
    canceled:"Cancelled",
    closed:"Incomplete order",
    InvalidOrders:"Invalid orders",
    noMore:"No more",
    orderNumber:"Order Ref",
    amountPayable:"Immediate payment",
    immediatePayment:"Amount to pay",
    cancellationOrder:"cancellation of order",
    amountPaid:"Amount paid",
    confirmReceipt:"confirm receipt",
    logistics:"check the logistics",
    deleteOrder:"Delete order",
    refund:"refund",
    cancelHint:"After cancelling the order, the discounts enjoyed by this order may be cancelled too, do you agree?",
    canceltitle:"Please select the reasons of the cancellation (compulsory):",
    option1:"配送信息有误",
    option2:"发票信息有误",
    option3:"忘记使用优惠券、积分等",
    option4:"商品买错了",
    option5:"重复下单/误下单",
    bool:"confirm"
}

const langPackage = {
    cn:personalOrdersLangCN,
    en:personalOrdersLangEN
}

export {langPackage}
